import gql from 'graphql-tag';

export default gql`
  query MapSearchQuery(
    $term: String!
    $locationId: ID!
    $startTime: DateTime!
    $endTime: DateTime!
    $timeoutMilliseconds: Int
    $includeEmployees: Boolean!
    $draftId: ID
  ) {
    mapSearch(
      mapSearchQuery: {
        term: $term
        locationId: $locationId
        startTime: $startTime
        endTime: $endTime
        timeoutMilliseconds: $timeoutMilliseconds
        includeEmployees: $includeEmployees
        includeMapFeatures: true
        draftId: $draftId
      }
    ) {
      term
      locationId
      startTime
      endTime
      includeEmployees
      includeMapFeatures
      draftId
      items {
        type
        ... on MapFeatureSearchResultItem {
          feature {
            id
            name
            floor {
              id
              name
            }
            __typename
          }
        }
        ... on EmployeeMapSearchResultItem {
          employee {
            id
            name
            email
            profilePictureUrl
            nextAssignment {
              deskId
              deskName
              startTime
            }
            __typename
          }
        }
      }
    }
  }
`;
